import React, { Component, Fragment } from "react";
import Progress from "react-progressbar";
import Select from "./Select";
import ToggleButton from "./ToggleButton";
import YesNoButton from "./YesNoButton";
import CardContainer from "./CardContainer";
import Address from "./Address";
import FileDialog from "./FileDialog";
import DateInput from "./DateInput";
import CountryPicker from "./CountryPicker";
import { doSMS, clearZero } from "../functions/Auth";
import { animateScroll } from "react-scroll";
import { register } from "../functions/Auth";
import Firebase from "../firebasehelper";
import ErrorModal from "./ErrorModal";

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
let profile = {};
class MessageInput extends Component {
  state = {
    value: "",
    modalIsOpen: false,
    caption: "",
    content: "",
    profile: {
      value: "",
      isFocused: false,
      pin: "",
      phone: "",
      username: "",
      DOB: "",
      sms: "",
      email: "",
      password: "",
      personalType: "",
      spareType: "",
      animalType: "",
      socialType: "",
      employmentType: "",
      salary: "",
      addressType: ""
    },
    fileupload: 0
  };
  handleTouchStart = false;

  getStaticMessage() {
    const { addMessage, message, logo } = this.props;
    if (Array.isArray(message.message)) {
      return (
        <div className="message-array">
          {message.message.map((message, i) => {
            return (
              <div
                className={`message message-static ${
                  logo === "bolt" ? " " : "notbolt"
                }`}
                onTouchStart={() => {
                  addMessage({
                    type: "user",
                    ...message
                  });
                }}
                key={i}
              >
                {message.message}
              </div>
            );
          })}
        </div>
      );
    }
    return (
      <div
        className={`message message-static ${
          logo === "bolt" ? " " : "notbolt"
        }`}
        onClick={() => {
          addMessage(message);
          if (message.finish) {
            console.log("profile", profile);
            this.doSignup(profile);
          }
        }}
      >
        {message.message}
      </div>
    );
  }

  getInputMessage() {
    const { value, isFocused } = this.state;
    const { message, logo, isIphoneX, addMessage } = this.props;
    return (
      <div className="message-input-outer">
        {message.key === "sms" && (
          <div
            className={`button ${logo === "bolt" ? "" : "notbolt"}`}
            onClick={e => {
              this.handleTouchStart = true;
              addMessage({
                type: "user",
                message: "I didn't receive a code.",
                inputType: "input",
                key: "no_received"
              });
            }}
          >
            I didn't receive a code
          </div>
        )}
        {message.key === "company_site" && (
          <div
            className={`button ${logo === "bolt" ? "" : "notbolt"}`}
            onClick={e => {
              this.handleTouchStart = true;
              profile[message.key] = "I don't have one.";

              addMessage({
                type: "user",
                message: "I don't have one.",
                inputType: "input",
                key: "company_site"
              });
            }}
          >
            I don't have one
          </div>
        )}
        <div className="message-input-container">
          {message.key.includes("phone") && <p>+44</p>}
          {message.key === "salary" && <p>£</p>}
          {message.key === "company_site" && (
            <p
              style={{ marginLeft: 0, position: "absolute", top: 3, left: 20 }}
            >
              http://www
            </p>
          )}
          <input
            type="text"
            value={value}
            placeholder={message.placeholder}
            className={`${message.key.includes("phone") ? "phone" : ""}  ${
              message.key === "salary" ? "salary" : ""
            } ${message.key === "company_site" ? "company_site" : ""}`}
            onChange={this.onChange}
            onKeyPress={e => {
              if (e.charCode === 13) this.addMessage();
            }}
            onFocus={() => {
              this.setState(
                {
                  isFocused: true
                },
                () => {
                  animateScroll.scrollToBottom({
                    duration: 500,
                    smooth: "easeInOutQuad"
                  });
                }
              );
            }}
            onBlur={() => {
              this.setState({
                isFocused: false
              });
            }}
          />

          <div
            className={`send-button ${value ? "" : "disabled"} ${
              logo === "bolt" ? "" : "notbolt"
            }`}
            onClick={e => {
              if (value) {
                if (this.handleTouchStart) {
                  setTimeout(() => {
                    this.handleTouchStart = false;
                  }, 1000);
                  e.preventDefault();
                  return;
                }
                this.handleTouchStart = true;
                this.addMessage();
              } else
                this.setState({
                  modalIsOpen: true,
                  caption: "Warning",
                  content: "All fields are required!"
                });
            }}
          >
            Go
          </div>
        </div>
        {/* {isFocused && (
          <div
            style={{
              height: isIphoneX ? 350 : 300,
              backgroundColor: "#ffffff",
              marginLeft: -20,
              marginRight: -20
            }}
          />
        )} */}
      </div>
    );
  }

  getSelectInput() {
    const { addMessage, message } = this.props;
    const { options } = message;
    return <Select options={options} addMessage={addMessage} />;
  }

  setSelectedOption = index => {
    const { addMessage, message } = this.props;
    const selectedOption = message.options[index]["value"];
    console.log("selectedOption is", selectedOption);
    if (selectedOption === "Unemployed") {
      this.setState({
        modalIsOpen: true,
        caption: "We are sorry",
        content:
          "You cannot without either of employed or self-employed status!"
      });
    } else {
      profile[message.key] = selectedOption;
      addMessage({
        type: "user",
        message: selectedOption,
        inputType: "toggleInput",
        key: message.key
      });
    }
  };
  chooseOption = result => {
    const { addMessage, message } = this.props;
    if (message.key === "start" && result === "No") {
      this.setState({
        modalIsOpen: true,
        caption: "We are sorry",
        content:
          "We are unable to progress with your test and you'll be unable to unlock insider access!"
      });
    } else {
      profile[message.key] = result;
      addMessage({
        type: "user",
        message: result,
        inputType: "yes/no",
        key: message.key
      });
    }
  };
  getAddress() {
    const { addMessage, message } = this.props;
    return (
      <Address
        addMessage={this.addAddress}
        message={message}
        postcode={profile["postcode"]}
      />
    );
  }
  getDateMessage() {
    const { addMessage, logo, message } = this.props;
    return (
      <DateInput addMessage={this.addDate} logo={logo} message={message} />
    );
  }
  getToggleButton() {
    const { options } = this.props.message;
    return (
      <ToggleButton
        options={options}
        setSelectedOption={this.setSelectedOption}
      />
    );
  }
  getYesNoInput() {
    return <YesNoButton setSelectedOption={this.chooseOption} />;
  }
  getCardInput() {
    const { addMessage, message } = this.props;
    const { cards } = message;
    return (
      <CardContainer addMessage={addMessage} cards={cards} message={message} />
    );
  }
  getUploadDialog() {
    const { addMessage, logo, message } = this.props;
    return <FileDialog upload={this.upload} logo={logo} message={message} />;
  }
  getNation() {
    const { addMessage, logo, message } = this.props;
    return (
      <CountryPicker
        addMessage={this.addCountry}
        logo={logo}
        message={message}
      />
    );
  }
  onChange = e => {
    this.setState({
      value: e.target.value
    });
  };

  createPincode = () => {
    return Math.floor(100000 + Math.random() * 900000);
  };
  addAddress = address => {
    const { addMessage, message } = this.props;
    profile[message.key] = address;
    addMessage({
      message: address,
      ...message
    });
  };
  upload = file => {
    const { addMessage, message } = this.props;
    var metadata = {
      contentType: "image/jpeg"
    };

    var storageRef = Firebase.storage().ref();
    var uploadTask = storageRef.child("bank/" + file.name).put(file, metadata);
    let storage = Firebase.getStorage();
    let self = this;
    uploadTask.on(
      storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function(snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        self.setState({ fileupload: progress });
        console.log("Upload is " + progress + "% done");
      },
      function(error) {
        console.log(error.code);
      },
      function() {
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          profile[message.key] = downloadURL;
          let msg =
            message.key === "bankstatement"
              ? "Bank statement"
              : message.key + " document uploaded";
          addMessage({
            message: msg,
            ...message
          });
        });
      }
    );
  };
  addDate = date => {
    const { addMessage, message } = this.props;
    profile[message.key] = date;
    let status = profile["addressType"];
    addMessage({
      message: date,
      status: status,
      ...message
    });
    console.log("profile", profile);
  };
  addCountry = data => {
    const { addMessage, message } = this.props;
    profile[message.key] = data;
    addMessage({
      message: data,
      ...message
    });
    console.log("profile", profile);
  };
  jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  addMessage = () => {
    const { addMessage, message } = this.props;
    const { value } = this.state;
    if (message.key === "email") {
      if (value && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))
        this.setState({
          modalIsOpen: true,
          caption: "Invalid Email",
          content: "Please enter valid email address!"
        });
      else if (value) {
        profile[message.key] = value;
        addMessage({
          type: "user",
          message: value,
          inputType: "input",
          isNext: message.isNext
        });
      } else {
        profile[message.key] = null;
        addMessage({
          type: "user",
          message: "not now",
          inputType: "input",
          isNext: message.isNext
        });
      }
    } else if (message.key.includes("username")) {
      if (value && !/[a-zA-Z]+(\s|,)[a-zA-Z]{1,19}/.test(value))
        this.setState({
          modalIsOpen: true,
          caption: "Invalid Name",
          content: "Please enter valid FullName!"
        });
      else if (value) {
        let name = value.split(" ");
        let fname = name[0];
        let lname = name[1];
        let updated_name = this.jsUcfirst(fname) + " " + this.jsUcfirst(lname);
        profile[message.key] = updated_name;
        addMessage({
          type: "user",
          message: updated_name,
          inputType: "input",
          key: message.key,
          isNext: message.isNext
        });
      }
    } else if (message.key === "DOB") {
      if (
        value &&
        !/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
          value
        )
      )
        this.setState({
          modalIsOpen: true,
          caption: "Invalid format of date",
          content: "Please enter valid date format!"
        });
      else if (value) {
        profile[message.key] = value;
        addMessage({
          type: "user",
          message: value,
          inputType: "input",
          isNext: message.isNext
        });
      }
    } else if (message.key === "password") {
      if (
        value &&
        !/(?=^.{8,}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)[0-9a-zA-Z!@#$%^&*()]*$/.test(
          value
        )
      )
        this.setState({
          modalIsOpen: true,
          caption: "Password is not strong",
          content: "Please enter stronger password!"
        });
      else if (value) {
        profile["password"] = value;
        addMessage({
          type: "user",
          message: value,
          inputType: "input",
          isNext: message.isNext
        });
      }
    } else if (message.key === "salary") {
      if (value && !/^[0-9]*$/.test(value))
        this.setState({
          modalIsOpen: true,
          caption: "Salary should be number",
          content: "Please enter right amount of salary!"
        });
      else if (value) {
        let salary = "£" + numberWithCommas(value);
        addMessage({
          type: "user",
          message: salary,
          key: message.key,
          inputType: "input",
          isNext: message.isNext
        });
        profile[message.key] = value;
      }
    } else if (message.key === "company_site") {
      let site = "http://www" + value;
      addMessage({
        type: "user",
        message: site,
        key: message.key,
        inputType: "input",
        isNext: message.isNext
      });
      profile[message.key] = site;
    } else if (message.key.includes("_phone")) {
      let agentphone = "+971" + value;
      addMessage({
        type: "user",
        message: agentphone,
        key: message.key,
        inputType: "input",
        isNext: message.isNext
      });
      profile[message.key] = agentphone;
    } else if (message.key !== "email") {
      if (message.key === "phone") {
        let pin = this.createPincode();
        pin = pin.toString();
        console.log("pin", pin);
        let number = clearZero(value);
        let phone = "+971" + number;
        localStorage.setItem("phone", phone);
        localStorage.setItem("pin", pin);
        let response = doSMS(phone, pin);
        console.log("response", response);
      } else profile[message.key] = value;
      if (message.key === "sms") {
        let phone = localStorage.getItem("phone");
        let pin = localStorage.getItem("pin");
        if (pin === value) {
          profile["phone"] = phone;
          addMessage({
            type: "user",
            message: value,
            key: message.key,
            inputType: "input",
            isNext: message.isNext
          });
        } else {
          addMessage({
            type: "user",
            message: value,
            key: "wrong_sms",
            inputType: "input",
            isNext: message.isNext
          });
        }
      } else
        addMessage({
          type: "user",
          message: value,
          key: message.key,
          inputType: "input",
          isNext: message.isNext
        });
    }
    console.log("profile", profile);
  };
  componentWillLeave(callback) {
    const { message } = this.props;
    if (message.inputType !== "input") {
      this.setState({
        leaving: true
      });
      setTimeout(() => {
        callback();
      }, 400);
    } else callback();
  }
  doSignup = profile => {
    //Firebase.writeUserdata("1", profile);
    let name = profile.username.split(" ");
    const basic = {
      firstname: name[0],
      lastname: name[1],
      email: profile.email,
      key: profile.password,
      postcode: profile.postcode,
      number: profile.number,
      street: profile.street,
      city: profile.city,
      phonenumber: profile.phone,
      dob: profile.DOB,
      avatar: ""
    };
    register(basic)
      .then(res => {
        console.log("result", res);
        console.log("registration Successfully!");
        const { userId, memberId } = res;
        profile["memberId"] = memberId;
        Firebase.writeUserdata(userId, profile);
      })
      .catch(err => {
        console.log("error", err);
        return;
      });
  };
  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };
  render() {
    const { leaving, modalIsOpen, caption, content, fileupload } = this.state;
    const { message, logo } = this.props;
    return (
      <Fragment>
        <ErrorModal
          caption={caption}
          content={content}
          closeModal={this.closeModal}
          modalIsOpen={modalIsOpen}
          logo={logo}
        />
        {message && (
          <div
            className={`message-input-wrapper ${message.inputType} ${
              leaving ? "leaving" : ""
            }`}
          >
            {message.inputType === "static" ? this.getStaticMessage() : null}
            {message.inputType === "nation" ? this.getNation() : null}
            {message.inputType === "input" ? this.getInputMessage() : null}
            {message.inputType === "address" ? this.getAddress() : null}
            {message.inputType === "date" ? this.getDateMessage() : null}
            {message.inputType === "select" ? this.getSelectInput() : null}
            {message.inputType === "card" ? this.getCardInput() : null}
            {message.inputType === "yes/no" ? this.getYesNoInput() : null}
            {message.inputType === "upload" ? this.getUploadDialog() : null}
            {message.inputType === "toggleButton"
              ? this.getToggleButton()
              : null}
          </div>
        )}
        <Progress completed={fileupload} />
      </Fragment>
    );
  }
}

export default MessageInput;



// WEBPACK FOOTER //
// ./src/Components/MessageInput.js